import * as XLSX from 'xlsx-js-style';


export const defaultVisible = [
    'part_name',
    'description',
    'requiredQty',
    'deliveredQty',
    'distributedQty',
    'installedQty',
    'currentQty'
  ];
  
export const allColumns = [
    { key: 'part_name', label: 'Part Number' },
    { key: 'description', label: 'Part Description' },
    { key: 'requiredQty', label: 'Required Qty' },
    { key: 'deliveredQty', label: 'Delivered Qty' },
    { key: 'distributedQty', label: 'Distributed Qty' },
    { key: 'installedQty', label: 'Installed Qty' },
    { key: 'currentQty', label: 'Current Qty' },
    { key: 'damagedQty', label: 'Damaged Qty' },
    { key: 'remediateQty', label: 'Remediate Qty' },
    { key: 'DeficitQty', label: 'Deficit Qty' },
  ];
  
export const childHeaders = [
    { key: "date_time", label: 'Date & Time' },
    { key: "delivery_reference", label: 'Delivery Reference' },
    { key: 'deliveredQty', label: 'Delivered Qty' },
    { key: "quantity", label: "Quantity" },
    { key: "action", label: "Action" },
    { key: "comment", label: "Comment" }
  ];
  
  
export const exportInventoryToExcel = (inventoryData, projectInfo = {}, parentHeaders, childHeaders) => {
  
    const getLabel = (value) => {
      if(value === 0) {
        return "Devilery"
      } else if(value === 2) {
        return "Intersite movement issued"
      } else if(value === 3) {
        return "Intersite movement received"
      } else {
        return "-"
      }
    }
  
    const excelData = [];
    
    if (projectInfo.projectNumber) {
      excelData.push(['Project Number', projectInfo.projectNumber, '', '', '', '', '', '', '', '']);
    }
    if (projectInfo.projectName) {
      excelData.push(['Project Name', projectInfo.projectName, '', '', '', '', '', '', '', '']);
    }
    if (projectInfo.reportTitle) {
      excelData.push(['Report', projectInfo.reportTitle, '', '', '', '', '', '', '', '']);
    }
    if (projectInfo.reportDate) {
      excelData.push(['Report Date', projectInfo.reportDate, '', '', '', '', '', '', '', '']);
    }
    
    excelData.push(['', '', '', '', '', '', '', '', '', '']);
  
    excelData.push(parentHeaders.map(h => h.label));
  
    inventoryData.forEach(item => {
      const deficitQty = (item.required_qty || 0) - (item.current_qty || 0);
      
      const parentRow = [
        item.part_name || '',
        item.description || '',
        item.required_qty || 0,
        item.delivered_qty || 0,
        item.distributed_qty || 0,
        item.installed_qty || 0,
        item.current_qty || 0,
        item.damaged || 0,
        item.remediated_quantity || 0,
        deficitQty
      ];
      excelData.push(parentRow);
  
      if (item.inventory_logs && item.inventory_logs.length > 0) {
        const childHeaderRow = [
          '', 
          '  ' + childHeaders[0].label, 
          childHeaders[1].label, // Delivery Reference
          childHeaders[2].label, // Delivered Qty
          childHeaders[3].label, // Quantity
          childHeaders[4].label, // Comment
          childHeaders[5].label,
          '', '', '', ''
        ];
        excelData.push(childHeaderRow);
  
        item.inventory_logs.forEach(log => {
          const quantity = log.issued_quantity || log.received_quantity || 0;
          const action = getLabel(log?.purpose_code)
          const childRow = [
            '', 
            '    ' + (log.time || ''), 
            log.delivery_reference || '',
            log.received_quantity || 0,
            quantity,
            action,
            log.comments || '',
            '', '', '', ''
          ];
          excelData.push(childRow);
        });
  
        excelData.push(['', '', '', '', '', '', '', '', '', '']);
      }
    });
  
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);
  
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1976D2" } }, 
      alignment: { horizontal: "center", vertical: "center" },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };
  
    const childHeaderStyle = {
      font: { bold: true, color: { rgb: "000000" } },
      fill: { fgColor: { rgb: "E3F2FD" } }, // Light blue
      alignment: { horizontal: "center", vertical: "center" },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };
  
    const projectInfoStyle = {
      font: { bold: true, color: { rgb: "000000" } },
      fill: { fgColor: { rgb: "F5F5F5" } },
      alignment: { horizontal: "left", vertical: "center" }
    };
  
    const dataStyle = {
      alignment: { horizontal: "center", vertical: "center" },
      border: {
        top: { style: "thin", color: { rgb: "CCCCCC" } },
        bottom: { style: "thin", color: { rgb: "CCCCCC" } },
        left: { style: "thin", color: { rgb: "CCCCCC" } },
        right: { style: "thin", color: { rgb: "CCCCCC" } }
      }
    };
  
    const range = XLSX.utils.decode_range(ws['!ref']);
    
    const tableBorderStyle = {
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      },
      alignment: { horizontal: "center", vertical: "center" }
    };
    
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        
        if (!ws[cellAddress]) {
          ws[cellAddress] = { t: 's', v: '' };
        }
        
        ws[cellAddress].s = { ...tableBorderStyle };
      }
    }
    
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;
  
        const cellValue = ws[cellAddress].v;
        const cellValueStr = String(cellValue || '');
        
        if (R < 4 && C === 0 && (
          cellValueStr === 'Project Number' || 
          cellValueStr === 'Project Name' || 
          cellValueStr === 'Report' || 
          cellValueStr === 'Report Date'
        )) {
          ws[cellAddress].s = {
            ...projectInfoStyle,
            border: tableBorderStyle.border
          };
        }
        else if (R < 4 && C === 1 && cellValue) {
          ws[cellAddress].s = {
            font: { bold: true, color: { rgb: "000000" } },
            fill: { fgColor: { rgb: "F5F5F5" } },
            alignment: { horizontal: "left", vertical: "center" },
            border: tableBorderStyle.border
          };
        }
        else if (parentHeaders.some(h => h.label === cellValueStr)) {
          ws[cellAddress].s = {
            ...headerStyle,
            border: tableBorderStyle.border
          };
        }
        else if (cellValueStr && childHeaders.some(h => cellValueStr.includes(h.label))) {
          ws[cellAddress].s = {
            ...childHeaderStyle,
            border: tableBorderStyle.border
          };
        }
        else if (cellValue !== '' && cellValue != null) {
          ws[cellAddress].s = {
            ...dataStyle,
            border: tableBorderStyle.border
          };
        }
      }
    }
  
    const columnWidths = [
      { wch: 20 }, // Part Number
      { wch: 40 }, // Part Description
      { wch: 12 }, // Required Qty
      { wch: 12 }, // Delivered Qty
      { wch: 12 }, // Distributed Qty
      { wch: 12 }, // Installed Qty
      { wch: 12 }, // Current Qty
      { wch: 12 }, // Damaged Qty
      { wch: 12 }, // Remediate Qty
      { wch: 12 }  // Deficit Qty
    ];
    
    ws['!cols'] = columnWidths;
  
    XLSX.utils.book_append_sheet(wb, ws, "Inventory Report");
  
    const now = new Date();
    const dateStr = now.toISOString().split('T')[0];
    const filename = `Inventory_Report_${dateStr}.xlsx`;
  
    XLSX.writeFile(wb, filename);
  };